import { combineReducers } from 'redux';

import data from './data/reducer';
import scenes from './components/pages/reducer';


export default combineReducers({
    data,
    scenes,
});
